import { render, staticRenderFns } from "./GuidedTour.vue?vue&type=template&id=382f6f9b&scoped=true"
import script from "./GuidedTour.vue?vue&type=script&lang=js"
export * from "./GuidedTour.vue?vue&type=script&lang=js"
import style0 from "./GuidedTour.vue?vue&type=style&index=0&id=382f6f9b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "382f6f9b",
  null
  
)

export default component.exports